$(() => {
    let toggle = document.querySelector('.burger-toggle');

    toggle.addEventListener('click', function(e) {
        this.classList.toggle('opened');
    });

});